import axios from 'axios'
import { getAuthorizationToken } from './access.es6'
import { getEnvironmentInformation } from './utils.es6'
import { getPartnerConfigs } from './requests.es6'

let EnvironmentalInformation = null
EnvironmentalInformation = getEnvironmentInformation()

const USSD_SESSIONS_URL = EnvironmentalInformation
  ? EnvironmentalInformation.servicesURLs.ussdSessions
  : 'http://localhost:8090/'

const ussdSessionsInstance = axios.create({
  baseURL: USSD_SESSIONS_URL,
  headers: { 'Content-Type': 'application/json', Accept: 'application/json' }
})

function authHeader() {
  axios.defaults.headers.common.Authorization = `Bearer ${getAuthorizationToken()}`
}

// The org this partner's USSD flows live in, read from their own partner config
// (ussd_org_uuid, set via Partners > Update Partner Config) instead of a hardcoded partner code - any
// partner with that field and ussd_business_features_active set works automatically, no code change here.
// Cached per page load since the logged-in user's own partner doesn't change mid-session.
let cachedOrgUuid = null
export function getUssdOrgUuid() {
  if (cachedOrgUuid) {
    return Promise.resolve(cachedOrgUuid)
  }
  return getPartnerConfigs().then(response => {
    cachedOrgUuid = response.data.ussd_org_uuid
    return cachedOrgUuid
  })
}

export function getUssdFlows() {
  authHeader()
  return getUssdOrgUuid().then(org =>
    ussdSessionsInstance.get(`mr/business/flows?org=${org}`)
  )
}

export function getUssdSessions(msisdn) {
  authHeader()
  return getUssdOrgUuid().then(org =>
    ussdSessionsInstance.get(`mr/business/sessions?org=${org}&msisdn=${msisdn}`)
  )
}

export function getUssdSessionMessages(msisdn) {
  authHeader()
  return getUssdOrgUuid().then(org =>
    ussdSessionsInstance.get(`mr/business/messages?org=${org}&msisdn=${msisdn}`)
  )
}

export function simulateStart(flow, msisdn) {
  authHeader()
  return getUssdOrgUuid().then(org =>
    ussdSessionsInstance.post(`mr/business/simulate/start?org=${org}`, {
      flow,
      msisdn
    })
  )
}

export function simulateResume(msisdn, session, input) {
  authHeader()
  return getUssdOrgUuid().then(org =>
    ussdSessionsInstance.post(`mr/business/simulate/resume?org=${org}`, {
      msisdn,
      session,
      input
    })
  )
}
